import { gql } from "@apollo/client";

// Student subject queries and mutations used by SubjectStudentContent.

export const SUBJECT_QUERY = gql`
  query Subject($id: ID!) {
    subject(id: $id) {
      title
    }
  }
`;

export const USER_NAME_QUERY = gql`
  query UserName($id: ID!) {
    user(id: $id) {
      id
      name
    }
  }
`;

export const SUBJECT_DETAIL_BLOCKS_QUERY = gql`
  query SubjectDetailBlocks($subjectId: ID!) {
    subjectDetailBlocks(subjectId: $subjectId) {
      id
      position
      html
    }
  }
`;

export const LESSON_CONTENTS_QUERY = gql`
  query LessonContentsByLesson($lessonId: ID!) {
    lessonContentsByLesson(lessonId: $lessonId) {
      id
      contentType
      contentData
      position
      aiEnabled
    }
  }
`;

export const QUIZZES_QUERY = gql`
  query QuizzesByLesson($lessonId: ID!) {
    quizzesByLesson(lessonId: $lessonId) {
      id
      lessonId
      question
      questionType
      position
      isKlausurRelevant
      requiredForCompletion
      difficulty
      sourceType
      explanation
      hint
    }
  }
`;

export const QUIZ_ATTEMPTS_BY_USER = gql`
  query QuizAttemptsByUser($userId: ID!) {
    quizAttemptsByUser(userId: $userId) {
      quizId
      selectedOptionIds
      isCorrect
    }
  }
`;

export const SUBJECT_AI_CHATS_BY_USER_QUERY = gql`
  query SubjectAIChatsByUser($userID: ID!) {
    listSubjectAIChatsByUser(userID: $userID) {
      id
      userID
      subjectID
      conversation {
        role
        content
      }
    }
  }
`;

export const QUIZ_OPTIONS_QUERY = gql`
  query QuizOptionsByQuiz($quizId: ID!) {
    quizOptionsByQuiz(quizId: $quizId) {
      id
      optionText
      isCorrect
      position
    }
  }
`;

export const LESSON_TASKS_QUERY = gql`
  query LessonTasks($lessonID: ID!) {
    lessonTasks(lessonID: $lessonID) {
      id
      lessonID
      originTaskID
      generatedForUserID
      title
      taskText
      hintText
      answerText
      position
      difficulty
      estimatedMinutes
      sourceType
      isPublished
    }
  }
`;

export const ALTKLAUSUREN_QUERY = gql`
  query StudentAltklausuren($subjectID: ID!) {
    altklausuren(subjectID: $subjectID) {
      id
      title
      description
      isPublished
      sourceType
      generatedForUserId
      createdBy
      versions {
        id
        title
        versionDate
        description
        sourceType
        timeLimitSeconds
        isPublished
        isLocked
        quizQuestions {
          id
          position
          questionText
          questionType
          explanation
          hint
          points
          options {
            id
            position
            optionText
            isCorrect
          }
        }
        tasks {
          id
          originTaskID
          generatedForUserID
          title
          taskText
          hintText
          answerText
          position
          difficulty
          estimatedMinutes
          sourceType
          isPublished
          createdBy
        }
      }
    }
  }
`;

export const START_ALTKLAUSUR_QUIZ_SESSION_MUTATION = gql`
  mutation StartAltklausurQuizSession($input: StartAltklausurQuizSessionInput!) {
    startAltklausurQuizSession(input: $input) {
      id
      altklausurVersionID
      status
      sessionQuestions {
        id
        questionID
        position
        isAnswered
        isCorrect
        pointsEarned
        selectedOptionIds
      }
    }
  }
`;

export const SAVE_ALTKLAUSUR_QUIZ_SESSION_ANSWER_MUTATION = gql`
  mutation SaveAltklausurQuizSessionAnswer($input: SaveAltklausurQuizSessionAnswerInput!) {
    saveAltklausurQuizSessionAnswer(input: $input) {
      id
      sessionID
      questionID
      position
      isAnswered
      isCorrect
      pointsEarned
      selectedOptionIds
    }
  }
`;

export const SUBMIT_QUIZ_ATTEMPT_MUTATION = gql`
  mutation SubmitQuizAttempt($input: SubmitQuizAttemptInput!) {
    submitQuizAttempt(input: $input) {
      id
    }
  }
`;

export const MARK_LESSON_COMPLETED_MUTATION = gql`
  mutation MarkLessonAsCompleted($input: MarkAsCompletedInput!) {
    markLessonAsCompleted(input: $input)
  }
`;

export const CREATE_ENROLLMENT_MUTATION = gql`
  mutation CreateEnrollment($input: CreateEnrollmentInput!) {
    createEnrollment(input: $input) {
      id
    }
  }
`;

export const CREATE_LESSON_ENROLLMENT_MUTATION = gql`
  mutation CreateLessonEnrollment($input: CreateLessonEnrollmentInput!) {
    createLessonEnrollment(input: $input) {
      id
    }
  }
`;

export const SUBMIT_LESSON_FEEDBACK_MUTATION = gql`
  mutation SubmitLessonFeedback($input: SubmitLessonFeedbackInput!) {
    submitLessonFeedback(input: $input) {
      id
      lessonId
      userId
      rating
      comment
    }
  }
`;
